import { render, staticRenderFns } from "./addCustomPolygon.vue?vue&type=template&id=4ad02db8"
import script from "./addCustomPolygon.vue?vue&type=script&lang=js"
export * from "./addCustomPolygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports